import { campaign } from "../config/campaign";

/**
 * Identificação obrigatória da propaganda eleitoral. Vive num componente só porque a
 * exigência é por peça: a galeria de artes é tão peça quanto o estúdio, e um rodapé
 * copiado a mão é um rodapé que sai de sincronia na primeira correção.
 */
export function CampaignDisclosure() {
  if (!campaign.election) return null;

  return (
    <footer className="campaign-disclosure" aria-label="Identificação oficial da campanha eleitoral">
      <p>
        <span className="campaign-copy-line">
          <strong>{campaign.shortName} © {campaign.election.year}</strong>
        </span>
        <span className="campaign-copy-line">
          Candidato a {campaign.office} por {campaign.election.state}
        </span>
        <span className="campaign-copy-line">
          {campaign.party} Nº {campaign.number}.
        </span>
      </p>
      <p>
        <span className="campaign-copy-line">
          <span className="campaign-ad-label">Propaganda Eleitoral</span> · Eleição {campaign.election.year}
        </span>
        <span className="campaign-copy-line">
          {campaign.election.legalName} {campaign.office}
        </span>
        <span className="campaign-copy-line">
          CNPJ: <span className="campaign-cnpj">{campaign.election.campaignCnpj}</span>.
        </span>
      </p>
    </footer>
  );
}
